import * as z from 'zod';

export const searchAddressResultSchema = z.object({
  id: z.number(),
  attrs: z.object({
    detail: z.string(),
    featureId: z.string().optional(),
    label: z.string().transform((value) => value.replace(/<\/?[^>]+(>|$)/g, '')),
    lat: z.number(),
    lon: z.number(),
    x: z.number(),
    y: z.number(),
  }),
});

export const searchAddressSchema = z.object({
  results: z.array(searchAddressResultSchema),
});

export const searchByPlotNrResultSchema = z.object({
  id: z.number(),
  attrs: z.object({
    lat: z.number(),
    lon: z.number(),
    x: z.number(),
    y: z.number(),
  }),
});

export const searchByPlotNumberSchema = z.object({
  results: z.array(searchByPlotNrResultSchema),
});

export const getAddressByPointSchema = z.object({
  results: z.array(
    z.object({
      attributes: z.object({
        egrid: z.string(),
        label: z.string(),
        dplz4: z.number(),
        dplzname: z.string(),
      }),
      geometry: z.object({
        x: z.number(),
        y: z.number(),
      }),
    }),
  ),
});

export const buildingLawEgridsFeatureSchema = z.object({
  type: z.string(),
  id: z.string(),
  geometry: z.object({
    type: z.string(),
    coordinates: z.union([
      z.array(z.array(z.tuple([z.number(), z.number()]))),
      z.array(z.array(z.array(z.tuple([z.number(), z.number()])))),
    ]),
  }),
  properties: z.object({
    egrid: z.string(),
    realestate_type: z.string(),
    number: z.string(),
    oereb_extract_pdf: z.string(),
    egris_egrid: z.string(),
  }),
});

export const getBuildingLawEgridsSchema = z.object({
  results: z.array(buildingLawEgridsFeatureSchema),
});
